export const socialsData = {
  github: "https://github.com/alakmodak99",
  linkedIn: "https://www.linkedin.com/in/alak-modak-4879691b7/",
  codepen: "https://leetcode.com/u/alakmodak_99/",
  // twitter: 'https://twitter.com/',
  // reddit: 'https://www.reddit.com/user/',
  // blogger: 'https://www.blogger.com/',
  // medium: 'https://medium.com/@',
  // stackOverflow: 'https://stackoverflow.com/users/',
  // gitlab: 'https://gitlab.com/',
  // youtube: 'https://youtube.com/'
};
